import {z} from 'zod';

import {UuidResponseBodySchema} from '@dms/api/shared';

export const CreateVehicleCostPresetRequestBodySchema = z.object({
  name: z.string(),
  vehicleId: z.string(),
  costIds: z.array(z.string()),
});

export const CreateVehicleEarningPresetRequestBodySchema = z.object({
  name: z.string(),
  vehicleId: z.string(),
  earningIds: z.array(z.string()),
});

export const ListVehicleCostCategoriesApiArgSchemaVehicleFinance = z.void();

export const CreateVehicleCostPresetApiArgSchema = z.object({
  createVehicleCostPresetRequestBody: CreateVehicleCostPresetRequestBodySchema,
});

export const CreateVehicleEarningPresetApiArgSchema = z.object({
  createVehicleEarningPresetRequestBody: CreateVehicleEarningPresetRequestBodySchema,
});

export const ListVehicleCostResponseBodySchema = z.object({
  id: z.string(),
  name: z.string(),
});

export const ListVehicleCostsApiArgSchema = z.object({
  vehicleId: z.string(),
  type: z.literal('manual').nullable().optional(),
});

export type ListVehicleCostCategoriesApiArgVehicleFinance = z.infer<
  typeof ListVehicleCostCategoriesApiArgSchemaVehicleFinance
>;
export type CreateVehicleCostPresetApiResponse = /** status 201  */ z.infer<
  typeof UuidResponseBodySchema
>;
export type CreateVehicleCostPresetApiArg = z.infer<typeof CreateVehicleCostPresetApiArgSchema>;
export type CreateVehicleEarningPresetApiResponse = /** status 201  */ z.infer<
  typeof UuidResponseBodySchema
>;
export type CreateVehicleEarningPresetApiArg = z.infer<
  typeof CreateVehicleEarningPresetApiArgSchema
>;
export type CreateVehicleCostPresetRequestBody = z.infer<
  typeof CreateVehicleCostPresetRequestBodySchema
>;
export type CreateVehicleEarningPresetRequestBody = z.infer<
  typeof CreateVehicleEarningPresetRequestBodySchema
>;
export type ListVehicleCostsApiResponse = /** status 200  */ z.infer<
  typeof ListVehicleCostResponseBodySchema
>[];
export type ListVehicleCostsApiArg = z.infer<typeof ListVehicleCostsApiArgSchema>;

export const ListedVehicleEarningResponseBodySchema = z.object({
  id: z.string(),
  name: z.string(),
});

export const ListVehicleEarningsApiArgSchema = z.object({
  vehicleId: z.string(),
  type: z.literal('manual').nullable().optional(),
});

export type ListVehicleEarningsApiResponse = /** status 200  */ z.infer<
  typeof ListedVehicleEarningResponseBodySchema
>[];

export type ListVehicleEarningsApiArg = z.infer<typeof ListVehicleEarningsApiArgSchema>;

export type ListedVehicleEarningResponseBody = z.infer<
  typeof ListedVehicleEarningResponseBodySchema
>;
